/** True when attachment opens in the browser without our API (same rule as HRTimesheets.vue links). */
export function isRemoteHRTimesheetAttachmentUrl(path) {
  if (path == null || path === '') return false;
  const s = String(path).trim();
  return /^https?:\/\//i.test(s) || s.startsWith('//');
}

export function formatHRTimesheetFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  if (bytes == null || Number.isNaN(Number(bytes))) return '—';
  const n = Number(bytes);
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(n) / Math.log(k));
  const idx = Math.min(Math.max(i, 0), sizes.length - 1);
  return `${parseFloat((n / k ** idx).toFixed(2))} ${sizes[idx]}`;
}
